// removed by extract-text-webpack-plugin
module.exports = {"about-section":"_2_wS8kif","aboutSection":"_2_wS8kif","toggle-more":"_3JEyLBsS","toggleMore":"_3JEyLBsS","headshot":"_1HxSKhye","intro":"_1SmoQEi5","box":"CH4dVKsq","title":"_2LIrtu2Q","more":"_1Lk9E20D","active":"_2l5fHQak"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutSection/AboutSection.pcss
// module id = 391
// module chunks = 0